export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line', count: 1280 },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line', count: 960 },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', count: 850 },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', count: 720 },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', count: 540 },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line', count: 680 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line', count: 420 },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-line', count: 390 },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line', count: 610 },
  { slug: 'fanzui', name: '犯罪片', icon: 'ri-police-car-line', count: 480 },
];

export interface Movie {
  id: number;
  title: string;
  subtitle: string;
  category: string;
  year: number;
  rating: number;
  duration: string;
  area: string;
  director: string;
  actors: string[];
  description: string;
  poster: string;
  isHot: boolean;
  isNew: boolean;
  updateDate: string;
  tags: string[];
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '战狼3：终极使命',
    subtitle: 'Wolf Warrior 3',
    category: 'dongzuo',
    year: 2026,
    rating: 8.7,
    duration: '128分钟',
    area: '中国大陆',
    director: '吴京',
    actors: ['吴京', '张译', '余男'],
    description: '冷锋再度出击，深入敌后执行一项看似不可能完成的任务。面对强大的国际雇佣兵组织，冷锋和他的战友们将用热血与勇气捍卫国家尊严。本片延续了战狼系列的硬核动作风格，同时加入了更多人性化的情感刻画，让观众在热血沸腾中感受到中国军人的铁血柔情。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20military%20action%20movie%20poster%20with%20soldier%20in%20combat%20gear%20holding%20weapon%2C%20dramatic%20lighting%2C%20cinematic%20war%20atmosphere%2C%20dark%20fiery%20background%2C%20intense%20expression%2C%20movie%20poster%20style%20with%20Chinese%20text%20space%2C%20professional%20film%20poster%20design&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    isHot: true,
    isNew: true,
    updateDate: '2026-08-01',
    tags: ['动作', '军事', '热血'],
  },
  {
    id: 2,
    title: '流浪地球3：新家园',
    subtitle: 'The Wandering Earth 3',
    category: 'kehuan',
    year: 2026,
    rating: 9.1,
    duration: '156分钟',
    area: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '在成功点燃木星之后，人类文明面临着全新的挑战。新的宜居星系被发现，但抵达那里需要穿越前所未有的宇宙危险。全人类再次团结，驾驶地球踏上更为壮阔的星际旅程。本片以宏大的科幻视角探讨了人类命运共同体的深刻主题，视觉效果震撼人心。',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20giant%20planet%20earth%20engines%20in%20deep%20space%2C%20nebula%20galaxy%20background%2C%20futuristic%20spaceships%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20scale%2C%20professional%20film%20poster%20design%2C%20dark%20atmospheric%20tones&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    isHot: true,
    isNew: true,
    updateDate: '2026-07-28',
    tags: ['科幻', '灾难', '冒险'],
  },
  {
    id: 3,
    title: '满江红2：山河泪',
    subtitle: 'Full River Red 2',
    category: 'xuanyi',
    year: 2026,
    rating: 8.5,
    duration: '142分钟',
    area: '中国大陆',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    description: '南宋绍兴年间，一桩离奇的密室杀人案牵出惊天阴谋。一个小兵与亲兵营副统领在一座封闭的院落中展开了一场关于忠诚与背叛的生死博弈。层层反转，步步惊心，每一刻都暗藏玄机，真相远比表面复杂得多。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20set%20in%20ancient%20China%20courtyard%2C%20traditional%20architecture%2C%20lantern%20lighting%2C%20soldiers%20in%20ancient%20armor%2C%20dramatic%20shadows%2C%20cinematic%20suspense%20atmosphere%2C%20dark%20red%20and%20gold%20color%20palette%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    isHot: true,
    isNew: false,
    updateDate: '2026-07-15',
    tags: ['悬疑', '历史', '剧情'],
  },
  {
    id: 4,
    title: '你好，李焕英2：时光回响',
    subtitle: 'Hi, Mom 2',
    category: 'xiju',
    year: 2026,
    rating: 8.9,
    duration: '135分钟',
    area: '中国大陆',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾'],
    description: '这一次，贾晓玲意外获得了一个可以改变过去的机会。她回到了母亲年轻时的另一个关键人生节点，试图帮助母亲做出不同的选择。然而每一次改变都带来了意想不到的连锁反应，让她对亲情有了更深刻的理解和感悟。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20heartwarming%20comedy%20drama%20movie%20poster%20with%20mother%20and%20daughter%20embracing%2C%20warm%20nostalgic%20lighting%2C%201980s%20Chinese%20factory%20background%2C%20soft%20golden%20tones%2C%20emotional%20family%20atmosphere%2C%20professional%20film%20poster%20design&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    isHot: true,
    isNew: false,
    updateDate: '2026-07-20',
    tags: ['喜剧', '亲情', '穿越'],
  },
  {
    id: 5,
    title: '封神第二部：战火西岐',
    subtitle: 'Creation of the Gods 2',
    category: 'dongzuo',
    year: 2026,
    rating: 8.8,
    duration: '150分钟',
    area: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    description: '殷商大军压境，西岐城危在旦夕。姜子牙率众神将力挽狂澜，一场关乎天下苍生的神魔大战全面爆发。本片延续了第一部的史诗气质，以更为宏大的战争场面和精湛的特效呈现了中国神话的壮阔与瑰丽。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20gods%20in%20battle%2C%20traditional%20Chinese%20armor%2C%20magical%20elements%2C%20dramatic%20sky%20with%20lightning%2C%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20scale%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    isHot: true,
    isNew: true,
    updateDate: '2026-08-02',
    tags: ['动作', '奇幻', '神话'],
  },
  {
    id: 6,
    title: '深海2：归途',
    subtitle: 'Deep Sea 2',
    category: 'donghua',
    year: 2026,
    rating: 8.6,
    duration: '118分钟',
    area: '中国大陆',
    director: '田晓鹏',
    actors: ['王梓璇', '李佳怡'],
    description: '参宿从深海世界的冒险中归来，却发现现实世界也正面临着一场巨大的危机。她必须重新潜入那片神秘的海域，寻找拯救两个世界的钥匙。全新升级的粒子水墨技术将呈现出更加绚丽多彩的梦幻海底世界。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20with%20magical%20underwater%20world%2C%20colorful%20coral%20reefs%2C%20glowing%20jellyfish%2C%20a%20young%20girl%20diving%20deep%2C%20ethereal%20particle%20effects%2C%20dreamlike%20ink%20wash%20painting%20style%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    isHot: false,
    isNew: true,
    updateDate: '2026-07-30',
    tags: ['动画', '奇幻', '冒险'],
  },
  {
    id: 7,
    title: '热烈2：舞动巅峰',
    subtitle: 'One and Only 2',
    category: 'xiju',
    year: 2026,
    rating: 8.3,
    duration: '125分钟',
    area: '中国大陆',
    director: '大鹏',
    actors: ['王一博', '黄渤', '刘敏涛'],
    description: '陈烁带领舞团成功晋级全国街舞大赛总决赛，面对来自世界各地的顶尖舞者，他们必须突破自我极限。在汗水与泪水中，这群年轻人用舞蹈诠释了热爱的力量，用坚持证明了梦想的价值。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20dance%20movie%20poster%20with%20street%20dancer%20in%20dynamic%20pose%2C%20neon%20stage%20lighting%2C%20urban%20background%2C%20energetic%20atmosphere%2C%20youthful%20vibrant%20style%2C%20warm%20golden%20and%20orange%20tones%2C%20professional%20film%20poster%20design&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    isHot: false,
    isNew: true,
    updateDate: '2026-07-25',
    tags: ['喜剧', '舞蹈', '青春'],
  },
  {
    id: 8,
    title: '长津湖2：水门桥之战',
    subtitle: 'The Battle at Lake Changjin 2',
    category: 'zhanzheng',
    year: 2026,
    rating: 9.0,
    duration: '160分钟',
    area: '中国大陆',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '段奕宏'],
    description: '在长津湖战役的关键阶段，志愿军战士们奉命攻占水门桥，切断敌军退路。在极端严寒和敌军猛烈火力的双重考验下，他们以血肉之躯筑起了钢铁长城。本片以震撼的战争场面刻画了中国军人的英勇无畏与牺牲精神。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20fighting%20in%20snowy%20mountain%20battlefield%2C%20winter%20camouflage%2C%20dramatic%20explosion%20in%20background%2C%20heroic%20stance%2C%20cold%20blue%20and%20fiery%20orange%20contrast%2C%20cinematic%20epic%20scale%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    isHot: true,
    isNew: false,
    updateDate: '2026-07-10',
    tags: ['战争', '历史', '爱国'],
  },
  {
    id: 9,
    title: '消失的她2：暗流',
    subtitle: 'Lost in the Stars 2',
    category: 'fanzui',
    year: 2026,
    rating: 8.4,
    duration: '130分钟',
    area: '中国大陆',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    description: '一起看似完美的密室失踪案，背后隐藏着惊人的真相。律师陈麦接手了一个不可能完成的任务——为一名被控谋杀妻子的丈夫辩护。在逐步揭开真相的过程中，她发现每个人都在撒谎，而最大的危险正悄然逼近。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20mysterious%20woman%20silhouette%2C%20rainy%20city%20night%2C%20neon%20reflections%2C%20suspenseful%20noir%20atmosphere%2C%20dark%20shadows%2C%20red%20and%20black%20color%20palette%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    isHot: false,
    isNew: true,
    updateDate: '2026-08-01',
    tags: ['犯罪', '悬疑', '剧情'],
  },
  {
    id: 10,
    title: '我和我的父辈2：岁月如歌',
    subtitle: 'My Country, My Parents 2',
    category: 'jilupian',
    year: 2026,
    rating: 8.2,
    duration: '145分钟',
    area: '中国大陆',
    director: '徐峥',
    actors: ['徐峥', '章子怡', '沈腾'],
    description: '以四个不同年代的家庭故事，串联起新中国成立以来的时代变迁。从改革开放的春潮涌动，到新时代的繁荣昌盛，每一个平凡家庭的不平凡故事都折射出伟大的时代精神与中国人的家国情怀。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20movie%20poster%20showing%20four%20generations%20of%20Chinese%20family%2C%20nostalgic%20warm%20lighting%2C%20different%20historical%20eras%20collage%20style%2C%20emotional%20connections%2C%20soft%20golden%20sepia%20tones%2C%20professional%20film%20poster%20design&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    isHot: false,
    isNew: false,
    updateDate: '2026-06-28',
    tags: ['纪录片', '家庭', '时代'],
  },
  {
    id: 11,
    title: '孤注一掷2：深渊',
    subtitle: 'No More Bets 2',
    category: 'fanzui',
    year: 2026,
    rating: 8.6,
    duration: '138分钟',
    area: '中国大陆',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君'],
    description: '程序员潘生从诈骗集团逃脱后，发现背后还有一个更为庞大的跨国犯罪网络。为了彻底摧毁这个罪恶王国，他深入虎穴，与警方紧密配合展开了一场惊心动魄的跨国追捕行动。本片以真实事件为蓝本，揭露了网络诈骗的黑暗内幕。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20tech%20aesthetic%2C%20computer%20screens%2C%20shadowy%20figures%2C%20Southeast%20Asian%20compound%20setting%2C%20tense%20suspenseful%20mood%2C%20green%20and%20red%20digital%20glow%2C%20professional%20film%20poster&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    isHot: false,
    isNew: false,
    updateDate: '2026-07-08',
    tags: ['犯罪', '惊悚', '现实'],
  },
  {
    id: 12,
    title: '飞驰人生3：极速传奇',
    subtitle: 'Pegasus 3',
    category: 'xiju',
    year: 2026,
    rating: 8.1,
    duration: '122分钟',
    area: '中国大陆',
    director: '韩寒',
    actors: ['沈腾', '尹正', '黄景瑜'],
    description: '张驰重返赛场后，面对新一代年轻车手的强有力挑战。在荣誉与梦想的驱策下，这位老将驾驶着改装赛车，在险峻的拉力赛道上展开了一场笑泪交织的速度对决。每一次漂移过弯都充满了韩寒式的幽默与热血。',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20rally%20car%20drifting%20on%20dusty%20mountain%20road%2C%20dynamic%20action%20shot%2C%20golden%20sunset%20lighting%2C%20speed%20motion%20blur%2C%20warm%20desert%20tones%2C%20professional%20film%20poster%20design&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    isHot: false,
    isNew: false,
    updateDate: '2026-07-05',
    tags: ['喜剧', '赛车', '励志'],
  },
];

export const hotMovies = movies.filter((m) => m.isHot);
export const newMovies = movies.filter((m) => m.isNew);
export const getMoviesByCategory = (slug: string) => movies.filter((m) => m.category === slug);
export const getMovieById = (id: number) => movies.find((m) => m.id === id);